import React from 'react';
import { Link } from 'react-router-dom';

function TempltList({ data, apiCallFun, editFun, delFun, name }) {
  return (
    <li className="flex-sec">
      <span
        className="chld-rw-txt margin0"
        onClick={() => apiCallFun(data?.id, name)}
      >
        {data?.label}
      </span>
	  <span className="right" style={{ width: '10%' }}>
		  <span className="right cursor" onClick={() => editFun(data?.id, name)} style={{ width: '100%', textAlign:'right', paddingBottom:'10px' }}>
			<Link>&#9998;</Link>
		  </span>
		  <span className="right cursor" onClick={() => delFun(data?.id, name)} style={{ width: '100%', textAlign:'right' }}>
			<Link className="red">&#10007;</Link>
		  </span>
	  </span>
    </li>
  );
}

export default TempltList;
